import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, CHECKOUT_URL, PACK_IMAGE, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-2 border-y-4 border-cta bg-cta-light" data-id="element-110" data-mp="8mdmfcb6rh3m">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-111" data-mp="dfyeknq3lguw">
        <p className="inline-block rounded-md bg-brand px-2 py-0.5 font-sub text-sm font-semibold leading-tight text-white" data-id="element-112" data-mp="icot36m984e7">
          Oferta especial — Sistema completo 6 en 1
        </p>
        <h2 id="oferta-titulo" className="mt-2 font-display text-[1.5rem] font-extrabold leading-[1.1] tracking-tight text-ink sm:text-4xl" data-id="element-113" data-mp="rf7v5oi7ucze">
          Comenzá hoy desde cero y avanzá a tu ritmo.
        </h2>

        <Reveal className="mt-3 overflow-hidden rounded-2xl border-4 border-dashed border-ink bg-white text-ink" data-id="element-114" data-mp="2t7m96chn2xaj">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block bg-canvas" data-id="element-115" data-mp="12nierpr5wjvl">
            <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos y 5 bonos incluidos`} className="block w-full" data-id="element-116" data-mp="xvh2i3tzut5k" />
          </a>
          <div className="p-3" data-id="element-117" data-mp="oxetp240qw7q">
            <p className="font-display text-sm font-extrabold uppercase leading-tight text-brand" data-id="element-118" data-mp="ou0vm62e1963">
              {PRODUCT_NAME}
            </p>
            <p className="mt-1 inline-block rounded-md bg-highlight px-2 py-0.5 font-display text-2xl font-extrabold leading-tight" data-id="element-119" data-mp="1gn1kyd0exl59">
              6 Tomos + 5 Bonos
            </p>
            <p className="mt-1 text-xs font-semibold text-ink/80 sm:text-sm" data-id="element-120" data-mp="17mv7gr4psl63">
              🎁 Bonos valorados en{' '}
              <span className="line-through decoration-2" data-id="element-121" data-mp="16sxq97ah2e3">{BONUS_TOTAL}</span>
            </p>

            <p className="mt-2 inline-block rounded-full bg-cta px-3 py-0.5 font-display text-xs font-extrabold uppercase text-white" data-id="element-122" data-mp="3sckmp59by8zb">
              🔥 Oferta especial
            </p>
            <p className="mt-1 font-display text-5xl font-black leading-none text-cta sm:text-6xl" data-id="element-123" data-mp="2ng7k22elacp">
              <span className="text-2xl text-ink sm:text-3xl" data-id="element-124" data-mp="3ktl1qv6809du">Hoy:</span>{' '}
              {PRICE}
            </p>
            <p className="mt-1 text-xs font-semibold text-ink/80" data-id="element-125" data-mp="3ou50g36fzl23">
              Pago único • Sin mensualidades • Acceso Digital
            </p>

            <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-3" data-id="element-126" data-mp="3b1f1ky5telnk">
              🚀 Sí, quiero el sistema completo por {PRICE}
            </CtaButton>
            <p className="mt-2.5 text-xs font-semibold text-ink/80" data-id="element-127" data-mp="316dd84jd5nm1">
              Acceso Inmediato • Garantía de 7 Días
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}